"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBindingIdentifier = isBindingIdentifier;
const BindingIdentifier_1 = require("../models/BindingIdentifier");
function isBindingIdentifier(value) {
    return (typeof value === 'object' &&
        value !== null &&
        value[BindingIdentifier_1.bindingIdentifierSymbol] === true);
}
//# sourceMappingURL=isBindingIdentifier.js.map